import { fetchForms } from 'common/actions/integrations/ConvertKit/actions/convertkitActions'
import {
  connectIntegrationByToken,
  disconnectIntegration,
} from 'common/actions/integrations/common/actions/integrationActions'
import * as atypes from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'

import { fetchConvertKitFields, fetchSequences, fetchTags } from '../actions/convertkitActions'

const initialState = {
  identityField: {
    value: null,
    option: null,
  },
  forms: null,
  sequences: null,
  tags: null,
  currentForm: '',
  currentSequence: '',
  currentTag: '',
  convertkitFields: null,
  isFetchingForms: false,
  isFetchingTags: false,
  isFetchingSequences: false,
  isFetchingConvertKitFields: false,
  bindings: {},
  mappings: {},
  isConnecting: false,
  isDisconnecting: false,
}

export default function integrationsReducer(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case fetchForms.pending.type: {
      return { ...state, isFetchingForms: true }
    }

    case fetchForms.rejected.type: {
      return { ...state, isFetchingForms: false }
    }

    case fetchForms.fulfilled.type: {
      const { payload } = action
      return { ...state, forms: payload.forms, isFetchingForms: false }
    }

    case atypes.CONVERTKIT_SET_FORM: {
      return { ...state, currentForm: data }
    }

    case fetchSequences.pending.type: {
      return { ...state, isFetchingSequences: true }
    }

    case fetchSequences.rejected.type: {
      return { ...state, isFetchingSequences: false }
    }

    case fetchSequences.fulfilled.type: {
      const { payload } = action
      return { ...state, sequences: payload.sequences, isFetchingSequences: false }
    }

    case atypes.CONVERTKIT_SET_SEQUENCE: {
      return { ...state, currentSequence: data }
    }

    case fetchTags.pending.type: {
      return { ...state, isFetchingTags: true }
    }

    case fetchTags.rejected.type: {
      return { ...state, isFetchingTags: false }
    }

    case fetchTags.fulfilled.type: {
      const { payload } = action
      return { ...state, tags: payload.tags, isFetchingTags: false }
    }

    case atypes.CONVERTKIT_SET_TAG: {
      return { ...state, currentTag: data }
    }

    case fetchConvertKitFields.pending.type: {
      return { ...state, isFetchingConvertKitFields: true }
    }

    case fetchConvertKitFields.rejected.type: {
      return { ...state, isFetchingConvertKitFields: false }
    }

    case fetchConvertKitFields.fulfilled.type: {
      const { payload } = action
      return { ...state, convertkitFields: payload.fields, isFetchingConvertKitFields: false }
    }

    case atypes.CONVERTKIT_SET_BINDINGS: {
      return { ...state, bindings: { ...state.bindings, ...data } }
    }

    case atypes.CONVERTKIT_SET_MAPPINGS: {
      return { ...state, mappings: { ...state.mappings, ...data } }
    }

    case atypes.CONVERTKIT_SET_IDENTITY_FIELD: {
      return { ...state, identityField: data }
    }

    case atypes.INTEGRATION_RESET: {
      return {
        ...state,
        ...initialState,
      }
    }

    case connectIntegrationByToken.pending.type: {
      return { ...state, isConnecting: true }
    }

    case connectIntegrationByToken.fulfilled.type:
    case connectIntegrationByToken.rejected.type: {
      return { ...state, isConnecting: false }
    }

    case disconnectIntegration.pending.type: {
      return { ...state, isDisconnecting: true }
    }
    case disconnectIntegration.fulfilled.type: {
      return { ...state, isDisconnecting: false }
    }
  }

  return state
}
